/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconSize} from '../types/types';

export type PauseIconProps = {
  color?: string;
  size?: IconSize | number;
}

/*
 * Defines the Design Language System (DLS) Pause Icon component.
 */
export const PauseIcon = ({size = 20, color = dlsColor('grey3')}: PauseIconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill='none'>
      <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" fill={color} />
    </svg>
  );
};

export default PauseIcon;
